/* Fourth Man Roasters — "second pound = free shipping" cart nudge.
 *
 * When the cart holds coffee but under FREE_SHIP_LBS pounds (i.e. a single 1 lb
 * bag), prompt the shopper to add a second pound — either another 1 lb bag or by
 * switching to the 2 lb size. The free shipping itself is granted at checkout by
 * the delivery Shopify Function (cart.delivery-options.discounts, 2+ lb of coffee);
 * THIS file is only the encouragement.
 *
 * Cart-only, non-blocking, degrades silently, never breaks the cart. Renders just
 * above the rep-referral field (cart page + drawer). Sibling of fmr-attribution.js.
 */
(function () {
  var FREE_SHIP_LBS = 2;
  var EMBER = '#c4431f', CREAM = '#fbeee6', INK = '#1a1512';

  function lbsOf(s) { var m = /([\d.]+)\s*lb/i.exec(s || ''); return m ? Number(m[1]) : 0; }

  function injectStyleOnce() {
    if (document.getElementById('fmr-fsn-style')) return;
    var s = document.createElement('style');
    s.id = 'fmr-fsn-style';
    s.textContent =
      '.fmr-fsn{margin:14px 0;padding:13px 15px;background:' + CREAM + ';border:1px solid ' + EMBER + ';border-radius:8px;font-family:inherit;color:' + INK + ';}' +
      '.fmr-fsn__msg{font-size:14px;line-height:1.4;margin:0 0 9px;}' +
      '.fmr-fsn__msg b{color:' + EMBER + ';}' +
      '.fmr-fsn__row{display:flex;gap:8px;flex-wrap:wrap;}' +
      '.fmr-fsn__btn{appearance:none;cursor:pointer;border:1px solid ' + EMBER + ';border-radius:6px;padding:8px 13px;font-size:13px;font-weight:700;font-family:inherit;line-height:1;}' +
      '.fmr-fsn__btn--primary{background:' + EMBER + ';color:#fff;}' +
      '.fmr-fsn__btn--ghost{background:transparent;color:' + EMBER + ';}' +
      '.fmr-fsn__btn[disabled]{opacity:.55;cursor:default;}';
    document.head.appendChild(s);
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
  }
  function addVariant(id, qty) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty }] }) });
  }

  // Same-roast 2 lb variant for a 1 lb line (for the "make it a 2 lb bag" path).
  function find2lbVariant(item) {
    var roast = (item.variant_title || '').split('/').pop().trim(); // "1 lb / Light" -> "Light"
    return fetch('/products/' + item.handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        return (p.variants || []).find(function (v) {
          return lbsOf(v.title) === 2 && v.available && v.title.toLowerCase().indexOf(roast.toLowerCase()) !== -1;
        }) || null;
      })
      .catch(function () { return null; });
  }

  function render(cart, stats) {
    // clear any prior nudge so we never stack or go stale
    document.querySelectorAll('.fmr-fsn').forEach(function (n) { n.remove(); });

    var st = stats;
    var boxes = document.querySelectorAll('[data-fmr-referral]');
    if (!(st.lbs > 0 && st.lbs < FREE_SHIP_LBS) || !st.firstOneLb || !boxes.length) return;

        injectStyleOnce();
        var need = FREE_SHIP_LBS - st.lbs;
        var needLabel = (need % 1 === 0 ? need : need.toFixed(1)) + ' lb';

        boxes.forEach(function (box) {
          var el = document.createElement('div');
          el.className = 'fmr-fsn fmr-injected';
          el.innerHTML =
            '<p class="fmr-fsn__msg"><b>Two bags ship for the price of one.</b> Add a second pound and your shipping stays exactly the same.</p>' +
            '<div class="fmr-fsn__row">' +
              '<button type="button" class="fmr-fsn__btn fmr-fsn__btn--primary" data-fmr-add>Add another pound</button>' +
            '</div>';

          // primary: bump the single-pound line to two pounds
          el.querySelector('[data-fmr-add]').addEventListener('click', function (e) {
            var btn = e.currentTarget; btn.disabled = true;
            changeLine(st.firstOneLb.key, st.firstOneLb.quantity + 1)
              .then(function () { window.location.reload(); })
              .catch(function () { btn.disabled = false; });
          });

          // secondary: swap a lone 1 lb bag for the 2 lb size (same roast, same price/lb)
          if (st.firstOneLb.quantity === 1) {
            var row = el.querySelector('.fmr-fsn__row');
            find2lbVariant(st.firstOneLb).then(function (v) {
              if (!v || !document.body.contains(el)) return;
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'fmr-fsn__btn fmr-fsn__btn--ghost';
              b.textContent = 'Make it a 2 lb bag';
              b.addEventListener('click', function () {
                b.disabled = true;
                addVariant(v.id, 1)
                  .then(function () { return changeLine(st.firstOneLb.key, 0); })
                  .then(function () { window.location.reload(); })
                  .catch(function () { b.disabled = false; });
              });
              row.appendChild(b);
            });
          }

          box.parentNode.insertBefore(el, box); // nudge sits just above the referral field
        });
  }

  // Lifecycle is owned by fmr-cart-mount.js: one observer, one debounce, shared
  // with the pickup banner. Do not add another observer here.
  //
  // Guarded: if fmr-cart-mount.js failed to load (partial theme push, a
  // blocker), window.FMR or onCartRender may not exist. Degrade to no banner
  // rather than an uncaught TypeError, per this file's own contract above.
  if (window.FMR && window.FMR.onCartRender) window.FMR.onCartRender(render);
})();
